import { MenuPrintConfiguration } from '@menu/models/menuPrintConfiguration';
import { MenuGridConfiguration } from '@menuGridGenerator/models';
import * as apiMenuGridGenerator from '@menuGridGenerator/api';
import * as api from './api';
import { sectionRequest } from './views/MenuEditor/api';
import * as MutationTypes from './mutationTypes';
import {
  Font, MenuSectionType, MenuTemplate, MomentOfConsume, Theme, MenuConfiguration
} from './models';
import { Section } from './views/MenuEditor/models';

export const momentOfConsumeListRequest = async ({
  commit,
  getters: { momentOfConsumeList }
}, pointOfSaleGuid) => {
  if (momentOfConsumeList.length === 0) {
    const response = await api.momentOfConsumeListRequest(pointOfSaleGuid);
    const momentOfConsumeListRes = MomentOfConsume.toInstanceList(response.data);
    commit(MutationTypes.MOMENT_OF_CONSUME_LIST_SUCCESS, momentOfConsumeListRes);
  }
  return momentOfConsumeList;
};

export const menuConfigurationRequest = async ({ commit }, menuConfigurationGuid = '') => {
  const response = await api.menuConfigurationRequest(menuConfigurationGuid);
  const menuConfiguration = MenuConfiguration.toInstance(response.data);
  commit(MutationTypes.MENU_CONFIGURATION_SUCCESS, menuConfiguration);
  return menuConfiguration;
};

export const editMenuConfigurationRequest = async ({ commit }, menuConfiguration) => {
  const response = await api.editMenuConfigurationRequest(menuConfiguration.guid, menuConfiguration.getFormData());
  const editedMenuConfiguration = MenuConfiguration.toInstance(response.data);
  commit(MutationTypes.EDIT_MENU_CONFIGURATION_SUCCESS, editedMenuConfiguration);
  return menuConfiguration;
};

export const menuPrintConfigurationRequest = async ({ commit }, menuPrintConfigurationGuid) => {
  const response = await api.menuPrintConfigurationRequest(menuPrintConfigurationGuid);
  const menuPrintConfigurationResponse = MenuPrintConfiguration.toInstance(response.data);
  commit(MutationTypes.MENU_PRINT_CONFIGURATION_REQUEST, menuPrintConfigurationResponse);
};

export const themeRequest = async ({ commit }, themeGuid = '') => {
  const response = await api.themeRequest(themeGuid);
  const theme = Theme.toInstance(response.data);
  commit(MutationTypes.THEME_SUCCESS, theme);
  return theme;
};

export const editThemeRequest = async ({ commit }, theme) => {
  const response = await api.editThemeRequest(theme.guid, theme);
  const editedTheme = Theme.toInstance(response);
  commit(MutationTypes.EDIT_THEME_SUCCESS, editedTheme);
  return theme;
};

export const menuSectionTypesRequest = async ({ commit, getters: { menuSectionTypesList } }) => {
  if (menuSectionTypesList.length === 0) {
    const response = await api.menuSectionTypeListRequest();
    const menuSectionTypeListRes = MenuSectionType.toInstanceList(response.data);
    commit(MutationTypes.MENUSECTION_TYPES_SUCCESS, menuSectionTypeListRes);
  }
};

export const templateListRequest = async ({ commit, getters: { templateList } }) => {
  if (templateList.length === 0) {
    const response = await api.templateListRequest();
    const templateListRes = MenuTemplate.toInstanceList(response.data);
    commit(MutationTypes.TEMPLATE_LIST_SUCCESS, templateListRes);
  }
};

export const menuFontListRequest = async ({ commit, getters: { menuFontList } }) => {
  if (menuFontList.length === 0) {
    const response = await api.menuFontListRequest();
    const fontList = response.data.results;
    const menuFontListRes = Font.toInstanceList(fontList);
    commit(MutationTypes.MENU_FONTS_LIST_SUCCESS, menuFontListRes);
  }
};

export const createMenuFontRequest = async ({ commit }, fontFormData) => {
  const response = await api.createMenuFontsRequest(fontFormData);
  const newFont = Font.toInstance(response.data);
  commit(MutationTypes.CREATE_MENU_FONTS_SUCCESS, newFont);
  return newFont;
};

export const deleteMenuFontRequest = async ({ commit }, fontGuid) => {
  await api.deleteMenuFontsRequest(fontGuid);
  commit(MutationTypes.DELETE_MENU_FONTS_SUCCESS, fontGuid);
};

export const printMenuSectionRequest = async ({ commit }, { menuGuid, type }) => {
  const response = await sectionRequest('', menuGuid, type);
  const sectionList = Section.toInstanceList(response.data.results);
  commit(MutationTypes.PRINT_MENU_SECTION_REQUEST, sectionList);
};

export const menuGridConfigurationRequest = async ({ commit }, menuGridConfigurationGuid) => {
  const response = await apiMenuGridGenerator.menuGridConfigurationRequest(menuGridConfigurationGuid);
  const menuGridConfiguration = MenuGridConfiguration.toInstance(response.data);
  commit(MutationTypes.MENU_GRID_CONFIGURATION_SUCCESS, menuGridConfiguration);
  return menuGridConfiguration;
};
